import {
  Asset,
  Customer,
  CustomStatus,
  Invoice,
  Job,
  MaintenanceAgreement,
  Project,
  PublicLinkObjectType
} from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  statusWorkflowId: number | null;
  objectType: PublicLinkObjectType;
  objectId: number;
}

interface ResponseDataType {
  custom_statuses: CustomStatus[] | null;
  is_root_related_entity_acts_as_template: boolean;
  related_customer: Customer | null;
  related_job: Job | null;
  related_invoices: Invoice[] | null;
  related_estimates: Invoice[] | null;
  related_project: Project | null;
  related_maintenance_agreements: MaintenanceAgreement[] | null;
  related_assets: Asset[] | null;
}

export const getCustomFormAdditionalDataRequest = ({
                                                     token,
                                                     statusWorkflowId,
                                                     objectType,
                                                     objectId,
                                                   }: RequestParams): Promise<ResponseDataType> => {
  const searchParams = new URLSearchParams();

  if (statusWorkflowId) {
    searchParams.append('status_workflow_id', statusWorkflowId.toString());
  }
  if (objectType) {
    searchParams.append('object_type', objectType);
  }
  if (objectId) {
    searchParams.append('object_id', objectId.toString());
  }

  return ApiServiceInstance.makeRequest(`/custom-form/additional-data?${ searchParams.toString() }`, {
    token,
  });
};